import { useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const Home = () => {
  const [show, setShow] = useState(false);
  const [text, setText] = useState("");
  const [androidLink, setAndroidLink] = useState("");
  const [iosLink, setIosLink] = useState("");

  const handleClose = () => {
    setShow(false);
    setAndroidLink("");
    setIosLink("");
  };
  const handleShow = (infoText, androidLink, iosLink) => {
    setShow(true);
    setText(infoText);
    setAndroidLink(androidLink);
    setIosLink(iosLink);
  };

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      {/* banner area start */}
      <section className="main-banner-area">
        <Container>
          <div className="main-banner-inner">
            <Row>
              <Col lg={6}>
                <div className="main-banner-content">
                  <h1>
                    <span>Union</span> Africa's All-in-One App
                  </h1>
                  <p>Your Everyday Solution for Seamless Rides</p>
                  <div className="about-app-btns-body position-relative">
                    <div className="about-app-action-btn">
                      <Button className="primary-btns" onClick={()=> handleShow("Passenger", "https://play.google.com/store/apps/details?id=com.union.passenger", "https://apps.apple.com/us/app/union-request-a-ride/id6739698569")}>
                        Passenger App
                      </Button>
                      <Button className="primary-btns outline-btns" onClick={()=> handleShow("Driver", "https://play.google.com/store/search?q=union%20rider&c=apps&hl=en", "https://apps.apple.com/us/app/union-driver-rider-captain/id6739698610")}>
                        Driver App
                      </Button>
                    </div>
                    <a href="tel:+0800280025">
                      <p className="toll-free-number">
                        <img
                          className="me-2"
                          alt="call-icon"
                          src={
                            require("../assets/images/call-icon.svg").default
                          }
                        />{" "}
                        Toll Free: 0800280025
                      </p>
                    </a>
                    <img
                      className="line-arrow position-absolute"
                      alt="line-img"
                      src={require("../assets/images/line-arrow.svg").default}
                    />{" "}
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-banner-img">
                  <img
                    className=""
                    src={
                      require("../assets/images/main-banner-img.svg").default
                    }
                  />
                  {/* <img
                    className="mobile-view-banner"
                    src={
                      require("../assets/images/mobile-banner-img.svg").default
                    }
                  /> */}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      {/* banner area end */}

      {/* about area start */}
      <section className="about-area" id="about">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="about-image-area">
                <img src={require("../assets/images/about-img.png")} />
              </div>
            </Col>
            <Col md={6}>
              <div className="about-content-area">
                <h3>About Us</h3>
                <p>
                  Enjoy seamless convenience with Union Car and Boda , perfect
                  for personal, corporate, and team travel needs.
                </p>
                <div className="about-inner-content">
                  <img src={require("../assets/images/vision.svg").default} />
                  <h6>Vision</h6>
                  <p>
                    Enjoy seamless convenience with Union Car and Boda , perfect
                    for personal, corporate, and team travel needs.
                  </p>
                </div>
                <div className="about-inner-content">
                  <img src={require("../assets/images/vision.svg").default} />
                  <h6>Mission</h6>
                  <p>
                    To prioritize safety, convenience, and affordability by
                    connecting riders with trained, top-rated, and trusted
                    drivers. Through our commitment to excellence, we aim to
                    deliver peace of mind and exceptional service in every
                    journey.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* about area end */}

      {/* features area start */}
      <section className="features-area" id="features">
        <Container className="mt-5">
          <div className="features-content">
            <h3>Our Features</h3>
            <p>
              Travel in comfort and style with <span>Union Car & Boda</span>
            </p>
            <Row>
              <Col md={4}>
                <div className="features-content-box">
                  <img src={require("../assets/images/feature1.svg").default} />
                  <p>
                    Safe and reliable. Travel with trained, trusted drivers.
                  </p>
                </div>
              </Col>
              <Col md={4}>
                <div className="features-content-box">
                  <img src={require("../assets/images/feature2.svg").default} />
                  <p>No negotiations, just safe rides.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="features-content-box">
                  <img src={require("../assets/images/feature3.svg").default} />
                  <p>
                    Safe and reliable. Travel with trained, trusted drivers.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      {/* features area end */}

      {/* service area start */}
      <section className="service-area" id="service">
        <Container className="mt-5">
          <div className="service-area-content">
            <div className="features-content">
              <h3>Our Services</h3>
              <p>
                Enjoy seamless convenience with Union Car and Boda , perfect for
                personal, corporate, and team travel needs.
              </p>
            </div>
            <Tabs
              defaultActiveKey="home"
              id="uncontrolled-tab-example"
              className="mb-4"
            >
              <Tab eventKey="home" title="Union Boda">
                <div className="service-tab-content">
                  <img src={require("../assets/images/bike-img.png")} />
                </div>
              </Tab>
              <Tab eventKey="profile" title="Union Car">
                <div className="service-tab-content car-area">
                  <img src={require("../assets/images/car.svg").default} />
                </div>
              </Tab>
            </Tabs>
          </div>
        </Container>
      </section>
      {/* service area end */}

      {/* learn more area start */}
      <section className="learn-more-area">
        <Container>
          <Row>
            <Col md={12}>
              <Row className="learn-more-inner">
                <Col md={6}>
                  <div className="learn-more-content">
                    <p>
                      Want to learn more about Union? Stay informed with our
                      blog and discover insightful articles from our expert
                      community.
                    </p>
                    <a href="https://x.com/UnionAppUg" target="_blank">
                      <Button type="button" variant="unset">
                        See More
                      </Button>
                    </a>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="book-image">
                    <img src={require("../assets/images/blog-img.png")} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      {/* learn more area end */}
      {/* modal start */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="rounded-bg-modal"
      >
        <Modal.Header closeButton className="border-0 p-0"></Modal.Header>
        <Modal.Body>
          <div className="about-app-action-btn text-center">
            <Button className="primary-btns">
              {text} App
            </Button>
            <div className="app-sotre-img">
              <ul>
                <li>
                  <a href={androidLink} target="_blank" rel="noopener noreferrer">
                    {" "}
                    <img
                      src={require("../assets/images/goggle-pay.svg").default}
                    />
                  </a>
                </li>
                <li>
                  <a href={iosLink} target="_blank" rel="noopener noreferrer">
                    {" "}
                    <img
                      src={require("../assets/images/app-store.svg").default}
                    />
                  </a>
                </li>
                <li>
                  <a href="">
                    {" "}
                    <img
                      src={
                        require("../assets/images/app-galery-store.svg").default
                      }
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal end */}
    </>
  );
};
export default Home;
